import {useMemo} from 'react';
import {useQuery} from 'react-query';
import {UserAPIController} from '@api/user-api/user-api-controller';
import {UserAPIRequestImpl} from '@api/user-api/user-api-request';
import {normalizeVacationResponse} from '@utils/vacation';

export const currentUserVacationQueryKey = (userId?: string) => [
  'current-user-vacation',
  userId,
];

export const useHeaderVacation = (userId?: string, isOutOfOffice = false) => {
  const controller = useMemo(
    () => new UserAPIController(new UserAPIRequestImpl()),
    [],
  );
  const query = useQuery(
    currentUserVacationQueryKey(userId),
    () => controller.fetchUserVacation(userId as string),
    {
      enabled: Boolean(userId && isOutOfOffice),
      refetchOnWindowFocus: false,
    },
  );

  return {
    vacation: normalizeVacationResponse(query.data),
    isLoading: query.isLoading,
  };
};
